import { solution, unicodeSplit } from '../../lib/words'
import { Cell } from './Cell'

type Props = {
  guess: string
  className: string
  theme: string
}

export const CurrentRow = ({ guess, className, theme }: Props) => {
  const splitGuess = unicodeSplit(guess)
  const emptyCells = Array.from(Array(solution.length - splitGuess.length))
  const classes = `flex justify-center mb-1 ${className}`

  return (
    <div className={classes}>
      {splitGuess.map((letter, i) => (
        <Cell key={i} value={letter} theme={theme} />
      ))}
      {emptyCells.map((_, i) => (
        <Cell key={i} theme={theme} />
      ))}
    </div>
  )
}
